import { eventMeta, type EventTypeCatalog, type MaintenanceTask } from '@/types/maintenanceTask'

/**
 * The Tasks worklist's default order: the most recently created first, so a
 * new event lands at the top, and a task stays where it is when it is started,
 * assigned or goes overdue — status and priority are column sorts, not the
 * default. Fully determined, so it never depends on the order the server
 * happened to return rows in (z8nrz7fb9k).
 */

/**
 * The newest created first; tasks generated together (one creation time) by
 * the soonest due. Bookings carry no creation time and sit below the work.
 */
function byNewestThenSoonest(a: MaintenanceTask, b: MaintenanceTask): number {
  const due = (t: MaintenanceTask) => t.window?.startsAt ?? t.dueDate
  return (b.createdAt ?? '').localeCompare(a.createdAt ?? '') || due(a).localeCompare(due(b))
}

/**
 * The last word on order, so nothing is left to the server (z8nrz7fb9k).
 * Rows that tie are returned in no fixed order — one that changes when a row is
 * updated — so assigning a task made rows jump. Unit, then event type, then the
 * task.
 */
function byRowIdentity(a: MaintenanceTask, b: MaintenanceTask, catalog: EventTypeCatalog): number {
  return (
    a.equipmentId.localeCompare(b.equipmentId) ||
    eventMeta(a.eventType, catalog).label.localeCompare(eventMeta(b.eventType, catalog).label) ||
    a.id.localeCompare(b.id)
  )
}

/** The worklist's order: newest created, soonest due, then the row itself. */
export function compareWorklistRows(a: MaintenanceTask, b: MaintenanceTask, catalog: EventTypeCatalog): number {
  return byNewestThenSoonest(a, b) || byRowIdentity(a, b, catalog)
}
